module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic03.1c9b86e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic03.jpg
// module id = 600
// module chunks = 1